import { userEmploymentI18NDe } from "./user-employment-i18n-de";
import { userEmploymentI18NPl } from "./user-employment-i18n-pl";

const userEmploymentI18NEn = {
    employment: "Employment",
    startDate: "Start date",
    endDate: "End date",
    stillEmployed: "Still employed",
    addNew: "Add new period",
    back: "Back",
    present: "present",
};

export const userEmploymentI18N = {
    de: userEmploymentI18NDe,
    en: userEmploymentI18NEn,
    pl: userEmploymentI18NPl,
};
